var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"graphcontainer"},[_c(_vm.graphComponent,{tag:"component",attrs:{"selectedSurveyID":_vm.selectedSurveyID,"language":_vm.language}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }